import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ReferralPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  height: calc(100vh - ${pxToRem(54)});
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
              0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  overflow-x: auto;
  scrollbar-width: none;
`;

export const InfoContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  gap: ${pxToRem(24)};
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${pxToRem(24)};
  justify-content: space-between;
  align-items: center;
`;

export const FriendInviteContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: ${pxToRem(183)};
  gap: ${pxToRem(40)};
  min-width: ${pxToRem(360)};
  padding: ${pxToRem(16)};
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.08);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px 0px 0px ${pxToRem(6)} rgba(115, 83, 221, 0.37);
  background: linear-gradient(
    138.03deg,
    rgb(114, 82, 220) 32.06%,
    rgba(114, 82, 220, 0) 155.365%
  );
`;

export const FriendInviteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(6)};
`;

export const FriendInviteTitle = styled.h1`
  color: rgb(255, 255, 255);
  margin: 0;
  font-size: ${pxToRem(28)};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
`;

export const FriendInviteInfo = styled.span`
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(16)};
  font-weight: 400;
`;

export const CopyLinkWrapper = styled.div`
  display: flex;
`;

export const Button = styled.button`
  border-radius: ${pxToRem(8)};
  border: none;
  background: white;
  padding: ${pxToRem(12)} ${pxToRem(24)};
  cursor: pointer;
  margin-right: auto;

  img {
    margin-right: ${pxToRem(10)};
  }

  span {
    font-size: ${pxToRem(16)};
    font-weight: 600;
  }
`;

export const BalanceContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  max-height: ${pxToRem(183)};
  min-width: ${pxToRem(220)};
  padding: ${pxToRem(16)};
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const BalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${pxToRem(6)};
`;

export const BalanceTitle = styled.h1`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(16)};
  font-weight: 400;
`;

export const BalanceInfo = styled.span`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(28)};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WithdrawMoneyButton = styled.button`
  padding: ${pxToRem(14)} ${pxToRem(28)};
  border-radius: ${pxToRem(10)};
  background: rgba(114, 82, 220, 0.1);
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(16)};
  font-weight: 600;
  border: none;
  cursor: pointer;
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const StatsWrapper = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(140)}, 1fr));
  row-gap: ${pxToRem(24)};
  gap: ${pxToRem(24)};
  min-width: ${pxToRem(356)};
  padding: ${pxToRem(16)};
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
  overflow: auto;
`;

export const StatBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(6)};
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(16)};
  font-weight: 600;
  white-space: nowrap;

  span {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 600;
  }
`;

export const ChartWrapper = styled.div`
  margin-top: ${pxToRem(32)};
  padding: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  height: calc(100% - ${pxToRem(32)});
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
              0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);

  .recharts-wrapper {
    height: 100%;
  }
`;
